export default "__VITE_ASSET__BJfLshHq__"